import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import './style.css';

import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

class EditDemoQuestions extends Component {
  constructor(props){
    super(props)

    this.state={
      quesListArray : [],
      questionID : "",
      order_no :"",
      questions:"",
      catID:"",
      quesID : '',
      validationMsg: {},
      hideQuestionEdit : true,
      quesActionButton : "Edit",
      sub_ques : "",
      selectionType : "",
      showaddSubQuestionbutton : false,
      sub_ques_id : ''
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.saveData = this.saveData.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
  }

  componentWillMount(){
    if(this.props.editQuestionData){

      if(this.props.editQuestionData.sub_ques){
        this.setState({ showaddSubQuestionbutton : true});
      }
     
      this.setState({
        sub_ques_id : this.props.editQuestionData.sub_ques_id,
        quesID :  this.props.editQuestionData.ques_id,
        questionID : this.props.editQuestionData._id,
        catID : this.props.editQuestionData.cat_id,
        questions : this.props.editQuestionData.questions,
        order_no : this.props.editQuestionData.orderQues+ "",
        sub_ques : this.props.editQuestionData.sub_ques,
        selectionType : this.props.editQuestionData.selectionType,
      });
    }

    // if(this.props.demoGraphicsCategoriesQuesListSuccess && this.props.demoGraphicsCategoriesQuesListData){
    //   this.setState({
    //     quesListArray : this.props.demoGraphicsCategoriesQuesListData,
    //   });
    // }
  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsQuestionUpdateSuccess && nextProps.demoGraphicsQuestionsUpdateSuccessMessage){
      this.setState({hideQuestionEdit : true, quesActionButton:"Edit"});
      alert(nextProps.demoGraphicsQuestionsUpdateSuccessMessage);
    
      if(this.state.sub_ques == true){
        this.setState({ showaddSubQuestionbutton : true});
      }else{
        this.setState({ showaddSubQuestionbutton : false});
      }
      this.props.emptyDemographicsQuestions();
    }else if(nextProps.demoGraphicsQuestionsUpdateFailMessage){
      alert(nextProps.demoGraphicsQuestionsUpdateFailMessage);
      this.props.emptyDemographicsQuestions();
      if(!this.state.sub_ques){
        this.setState({ showaddSubQuestionbutton : false});
      }
    }
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
		let valid = true;
    let error = {};

	if (this.state.questions === "") {
      error.questions = "Can't leave empty";
			valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }

    if(this.state.sub_ques === ""){
        error.sub_ques = "Can't leave unselect";
        valid = false;
    }
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!(this.state.order_no).match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){

    if(this.state.hideQuestionEdit){
      this.setState({ hideQuestionEdit : false, quesActionButton : 'Update'});
    }else{
      let quesData = {};
      if (this.handleValidation()) {
        quesData.sub_ques_id = this.state.sub_ques_id;
        quesData.questionID = this.state.questionID
        quesData.ques_id = this.state.quesID
        quesData.cat_id = this.state.catID;
        quesData.orderQues = this.state.order_no;   
        quesData.questions = this.state.questions;
        quesData.selectionType = this.state.selectionType;  
        quesData.sub_ques = this.state.sub_ques ;
        this.props.updateQuestionDemographics(quesData);  
      }
    }   
  }

  backtoPage(){
    window.history.back();
  }

  softDeleteOption(data){
    this.props.softDeleteOption(data);
  }

  gotoSubquestionView(){
    this.props.gotoSubquestionView( this.state.catID, this.state.quesID);
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      let OptionsList = "";
    if(this.props.demoGraphicsCatQuesOptionsListData && this.props.demoGraphicsCatQuesOptionsListData.length > 0){
        let options = this.props.demoGraphicsCatQuesOptionsListData;
        OptionsList = Object.keys(options).map((item, index) => {
        let optionItem = options[item];


        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td >{ this.state.questions}</td>
            <td>{optionItem.options}</td>
            <td style ={{ textAlign : "center" }}>{optionItem.order_no}</td>
            <td className = "cat_action">
            <Link to={{
             pathname: '/demoOption/&q:'+this.state.quesID,
              state: {
                editOptionItemData : optionItem
              }
              }}>
              < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </Link>
            <button onClick = {this.softDeleteOption.bind(this, optionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
      OptionsList = "No data"
    }

    let showaddSubQuestionBtn = "";
    if(this.state.showaddSubQuestionbutton){
      showaddSubQuestionBtn = <button className = "demoRightbtn"  onClick={this.gotoSubquestionView.bind(this)}>Subquestions</button>
    }
    

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
            <div className = "studyheader"><h1> Edit Demographic's Question</h1></div>
            <div className = "setbackbutton">
            <br/>
            <button className = "editstudybackbtn"   onClick={this.backtoPage.bind(this)}>Back</button>
            {showaddSubQuestionBtn}
            <br/>

            <div className = "studypage">

            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>
            <label id = "addQuesLabel">Do you want to add Sub question ? </label>
            <input type="radio" name="sub_ques" value="true" defaultChecked={true == this.state.sub_ques}   onChange={this.onChangeRadio} disabled ={this.state.hideQuestionEdit}/> Yes
            <input style = {{marginLeft : "10%"}} type="radio" name="sub_ques" value="false" defaultChecked={false == this.state.sub_ques} onChange={this.onChangeRadio} disabled ={this.state.hideQuestionEdit}/> No
            <div style={{ color: "red", textAlign:"center"}} >{this.state.validationMsg.sub_ques}</div><br/><br/>
            <div>


            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} disabled ={this.state.hideQuestionEdit} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} disabled ={this.state.hideQuestionEdit} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption} disabled ={this.state.hideQuestionEdit}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >



            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >{this.state.quesActionButton}</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>

            <hr/>

        <div className = "catQuesListHeading"><h3>Question's Option List</h3></div>
        
        <Link to={{
              pathname: '/demoOption/&q:'+this.state.quesID,
             
              }}><button  className = "createCouponbtn" >
        Add Option</button></Link>
        
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Question</th>
              <th>Option</th>
              <th>Order No.</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {OptionsList}
            </tbody>
         </table>
        </div>

        </div>
        </div>
      );
    }
  }

export default EditDemoQuestions;


// WEBPACK FOOTER //
// ./src/components/demographics/editDemoQuestion.js